/** Matches server-side CurrencyService::DEFAULT_CURRENCY */
export const DEFAULT_CURRENCY = 'USD'

/**
 * Cross-convert using rate values from the site currencies API (same formula as CurrencyService::convert).
 *
 * @param {number} amount
 * @param {string} from ISO currency code
 * @param {string} to ISO currency code
 * @param {Record<string, { value?: number }>} currenciesByCode Uppercase keys
 * @returns {number}
 */
export function convertAmount (amount, from, to, currenciesByCode) {
  if (typeof amount !== 'number' || !Number.isFinite(amount)) {
    return amount
  }
  const f = String(from || '').toUpperCase()
  const t = String(to || '').toUpperCase()
  if (!f || !t || f === t) {
    return amount
  }
  const fromValue = currenciesByCode[f]?.value
  const toValue = currenciesByCode[t]?.value
  if (fromValue == null || toValue == null || fromValue === 0) {
    return amount
  }
  return Math.round((amount / fromValue) * toValue * 100) / 100
}

/**
 * @param {string|null|undefined} country Uppercase country code (e.g. GB, US)
 * @param {Record<string, string>|null|undefined} localCurrencies Country -> ISO currency
 * @returns {string}
 */
export function defaultDestinationForCountry (country, localCurrencies) {
  if (!country || !localCurrencies) {
    return DEFAULT_CURRENCY
  }
  const c = String(country).toUpperCase()
  return localCurrencies[c] || DEFAULT_CURRENCY
}
